










































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
//@ts-ignore
import { getModule } from "vuex-module-decorators";
import { NotificationEventBus } from "@/EventBus";
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import Users from "@/store/modules/Users";
import Sticky from 'vue-sticky-directive';
import VuexDialogTemplateScoringKeyEditor from "@/components/scoring-key/ModelScoringKeyEditorVuexDialog.vue";
import VuexDialogTemplateFactorScoringDefinitionCreator
    from "@/components/scoring-definition/ModelFactorScoringDefinitionCreatorVuexDialog.vue";
import Decisions from "@/store/modules/Decisions";
import Modelling from "@/store/modules/Modelling";
import { Factor, FactorGroup, FactorResource } from "@/api/model/FactorResource";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import FactorResourceBuilder from "@/components/model-builder/FactorResourceBuilder.vue";
import ModelBuilderRecursiveGroupComp from "@/views/ModelBuilder/ModelBuilderRecursiveGroup.vue";
import Apps from '@/store/modules/Apps';
import SandboxModelBuilder from '@/views/ModelBuilder/SandboxModelBuilder.vue'
import DiffDialog from '@/views/ModelBuilder/DiffDialog.vue'
import _ from "lodash";

const appsModule = getModule(Apps);
const usersModule = getModule(Users)
const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: {
        ModelBuilderRecursiveGroupComp,
        FactorResourceBuilder,
        VuexDialogTemplateFactorScoringDefinitionCreator,
        VuexDialogTemplateScoringKeyEditor,
        ConfirmationDialog,
        SandboxModelBuilder,
        DiffDialog
    },
    directives: {
        Sticky,
    },
})
export default class ModelBuilder extends Vue {
    @Prop({default:false, type:Boolean})
    appEmbed!: boolean;

    @Prop({default: false, type: Boolean})
    sandbox!: boolean

    @Prop({ default: false, type: Boolean })
    heroActive!: boolean

    private publishLoading = false;
    private unmodifiableProcessing = false;

    get appMenuName(){
        return appsModule.activeAppMenuName;
    }

    get mbDraggable() {
        return workspaceOptionsModule.mbDraggable;
    }

    set mbDraggable(val: boolean) {
        workspaceOptionsModule.setMbDraggable(val);
    }

    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }

    get commentBottomHeight() {
        return workspaceOptionsModule.commentBottomHeight;
    }

    get pinnedRight() {
        return workspaceOptionsModule.pinnedRight;
    }

    get openRight() {
        return workspaceOptionsModule.openRight;
    }
    get mainContainerSize() {
        let commentHeight = 0;
        if (this.commentVertical && this.pinnedRight) {
            commentHeight = this.commentBottomHeight;
        } else if (!this.pinnedRight && this.appEmbed) {
            commentHeight = 40;
        } else {
            commentHeight = 0;
        }

        //If sandbox then we want full height
        if(this.sandbox) {
            return `min-height: 100vh ; 
                    max-height: 100vh`;
        }

        if(this.appEmbed){
            if (this.heroActive) {
                return `max-height: calc(100vh - 140px - ${ commentHeight }px);`;
            } else {
                return `max-height: calc(100vh - 38px - ${ commentHeight }px);`;
            }
            
        } else {
            return `max-height: calc(100vh - 130px - ${ commentHeight }px);`;
        }
    }

    get cardContainerSize() {
        return `height:100%`
    }

    get modelDiff() {
        return modellingModule.modelDiff;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get currentUser() {
        return usersModule.currentUserProfile;
    }

    get isDecisionAdmin() {
        return this.selectedDecision && this.currentUser && (this.selectedDecision.ownerUserId === this.currentUser.userId
            || (decisionsModule.selectedDecisionUsers[this.currentUser.userId]
                && decisionsModule.selectedDecisionUsers[this.currentUser.userId].permissionAccess === 'ADMIN'))
    }

    get isDecisionOwner() {
        return this.selectedDecision && this.currentUser && this.selectedDecision.ownerUserId === this.currentUser.userId
    }

    //If sandox prop then use unpublished factorresources
    get factorResources() {
        if(this.sandbox) {
            return modellingModule.workingModelFactorResources;
        } else {
            return modellingModule.publishedModelFactorResources;
        }
    }

    get selectedCopyElement() {
        return modellingModule.copyFactorResource;
    }

    get expansionValues() {
        return workspaceOptionsModule.draftExpansions;
    }

    get updating() {
        return modellingModule.updating
    }

    get editModel() {
        return workspaceOptionsModule.editModel;
    }

    @Watch('updating')
    private onUpdatingChange(newVal: boolean) {
        if (newVal) {
            NotificationEventBus.emitProcessingMessage()
        } else if (!newVal) {
            NotificationEventBus.emitSuccessMessage();
        }
    }


    mounted() {
        if (this.selectedDecision && this.currentUser && decisionsModule.selectedDecisionUsers) {
            // this.$router.push({name: 'App'})
           if (!this.selectedDecision.ownerUserId === this.currentUser.userId
            && !(decisionsModule.selectedDecisionUsers[this.currentUser.userId]
                && decisionsModule.selectedDecisionUsers[this.currentUser.userId].permissionAccess === 'ADMIN')){
                    this.$router.push({name: 'ChoiceSubmitter'});
            }
        }
    }

    @Watch('selectedDecision')
    private onDecisionChange() {
        if (this.selectedDecision && this.currentUser && decisionsModule.selectedDecisionUsers) {
            // this.$router.push({name: 'App'})
           if (!this.selectedDecision.ownerUserId === this.currentUser.userId
            && !(decisionsModule.selectedDecisionUsers[this.currentUser.userId]
                && decisionsModule.selectedDecisionUsers[this.currentUser.userId].permissionAccess === 'ADMIN')){
                    this.$router.push({name: 'ChoiceSubmitter'});
            }
        }
    }


    private async publishTemplate() {
        this.publishLoading = true;
        this.unmodifiableProcessing = true;
        try {
            let cloneOfDiff = _.cloneDeep(this.modelDiff);
            await modellingModule.publishModel();
            if(cloneOfDiff.additions.length > 0 && workspaceOptionsModule.activeFactorLists.length > 0) {
                let factors = cloneOfDiff.additions.map(factor => {
                    if(modellingModule.publishedModelFactorResources[factor])
                        return modellingModule.publishedModelFactorResources[factor]
                })
                await decisionsModule.addFactorsToSelectLists({factors: factors, listIds: workspaceOptionsModule.activeFactorLists})
            }
        } catch (error) {
            NotificationEventBus.emitFailedMessage({message: error.message});
        }
        this.unmodifiableProcessing = false;
        this.publishLoading = false;
    }

    private async discardChanges() {
        try {
            await modellingModule.discardSandboxChanges()
        } catch (error) {
            NotificationEventBus.emitFailedMessage({message: error.message});
        }

    }


    private async pasteElements(payload: { destinationId: string, destinationIndex?: number }) {
        if (!this.selectedCopyElement) return;
        this.unmodifiableProcessing = true;
        try {
            NotificationEventBus.emitProcessingMessage()
            await modellingModule.pasteFactorResourceSubTree({
                destinationId: payload.destinationId,
                destinationIndex: payload.destinationIndex,
                factorResource: this.selectedCopyElement
            })
            NotificationEventBus.emitSuccessMessage()
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e)
        }
        this.unmodifiableProcessing = false;
    }

     private async decisionPaste(payload:any) {
        this.unmodifiableProcessing = true;
        try {
            NotificationEventBus.emitProcessingMessage()
            await modellingModule.crossDecisionPasteFactorResource({
                destinationDecision: payload.decisionId,
                destinationId:'M',
                factorResource: this.factorResources[payload.factor]
            })
            NotificationEventBus.emitSuccessMessage()
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e)
        }
        this.unmodifiableProcessing = false;
    }
    
    private createdFactor(createdFactorResult: { factor: FactorResource, parentId: string }) {
        Vue.set(this.expansionValues, createdFactorResult.parentId, 0);
        if(createdFactorResult.factor.type === 'FACTOR_GROUP') {
            Vue.set(this.expansionValues, createdFactorResult.factor.id, 0);
        }
        if(this.sandbox) {
            document.getElementById(createdFactorResult.factor.id)!.scrollIntoView({behavior: "smooth", block: "center"});
        }
        // Broken in vuetify right now
        // goTo("#" + createdFactorResult.factor.id)
    }

    private async updateScoringDefinition(payload: { factorId: string, scoringDefinition: any }) {

        await Promise.all(payload.scoringDefinition.factors.map(async (factorId) => {
            (this.factorResources[factorId] as Factor).scoringDefinition = payload.scoringDefinition;
            return modellingModule.updateFactorResource(this.factorResources[factorId])
        }));

        
    }

    private async updateFactorGroupScoringKeys(payload: { factorId: string, scoringKeys: any[] | null }) {
        let factorGroup = this.factorResources[payload.factorId] as FactorGroup;
        if (payload.scoringKeys) {
            Vue.set(factorGroup, 'scoringKeyDefinition', {scoringKeys: payload.scoringKeys})
        } else {
            Vue.delete(factorGroup, 'scoringKeyDefinition');
        }
        await modellingModule.updateFactorResource(factorGroup)
    }

}


